import { Link } from "components/shared/Link";
import { SampleType } from "types/shared";
import styles from "./HeaderSearchResults.module.scss";

type HeaderSearchResultsProps = {
  results: SampleType[];
  closeModal: () => void;
};

export const HeaderSearchResults = ({ results, closeModal }: HeaderSearchResultsProps) => {
  return (
    <div className={styles.wrap}>
      <ul className={styles.resultsGroup}>
        {results.map(({ id, slug, title, subcategory }) => (
          <li key={id} className={styles.result}>
            <Link href={`/${slug}`} onClick={closeModal}>
              <h3 className={styles.resultTitle}>{title}</h3>
              <ul className={styles.resultList}>
                <li className={styles.resultListItem}>{subcategory.category.name}</li>
                <li className={styles.resultListItem}>{subcategory.name}</li>
              </ul>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
